import { useState } from "react";
import { toast } from "react-toastify";
import api from "../../../../../../../../api/api";
import { extractYoutubeUrlFromHtml, removeCloseImageSpans } from "../utils/fileHelpers";

export default function useAssignmentRubricSubmit({
  lowerSchoolPayload,
  formState,
  formAssignmentState,
  activeWorkboard,
  activeTab,
  chatHist,
  teacher_id,
  token,
  lesson_id,
  rubric_id,
  assignment_id,
  previesAssignment,
  previesRubric,
  eachAssignment_id,
  eachRubric_id,
  workboards,
  defaultWorkboardData,
  globleSaveData,
  course,
  room_id,
  SkipLessonflag,
  getassignmentdetails,
  assignmentsCountTwo,
  rubricCounttTwo,
  isAssignment,
  isRubric,
  setIstoggleClick,
  setGlobleOnChangeDataSave,
  setClickSaveBTN,
  setClickSaveRubricBTN,
  setAssignmentgeneration,
  setLoading,
  setShowCourseSuccessfully,
  setLoadingPublishSchoology,
  updateDefaultWorkboardData,
  updateWorkboardDataByName,
  updateGlobleSaveData,
  setLesson,
  setPreviesAssignment,
  setPreviesRubric,
  setEachAssignment_id,
  setEachRubric_id,
  setPopupVisible,
  setActiveTab,
  setFormState,
  setassignment_id,
  setrubric_id,
  setlesson_id,
  setAssingmentListOfID,
  setGlobleSaveData,
  setFormErrorAssignmentState,
  isRequired,
  checkAssignmentopen,
  isSaveChecker,
  setisSaveChecker,
  getLessons,
  getCourseDetails,
  params,
  currentHideTimerState,
  setHideTimerStates,
  setCallSwitchToRubricFun,
  setIsAssignment,
  setIsRubric,
  setActiveWorkboard,
  generateAllMode,
  assignmentsCount,
  setPendingAssignmentClickArgs,
  rubricCount,
  setPendingRubricClickArgs,
  setskipLessonSession,
  skipLessonSession,
  setIsSaveLoading,
  setGetSavedYoutubeLinks,
  createManuallyMode,
  stopGenerateAllMode,
  lesson,
  setTypeChanged,
  setGetSpecificAssignmentType,
  getSpecificAssignmentType,
  setFormAssignmentState,
  /** Lower School story flow — the story shell is the lesson description. */
  isStoryGeneration = false,
  setIsLessonSaved
}) {
  const handleAssinmentRubricSubmit = async (
    e,
    schoologystatus,
    switchschoologySync,
    isPersonalizeValue
  ) => {


    const EMPTY_LESSON_PLACEHOLDER_DESCRIPTION = "@$%^231#^#a5fgd%532^&4R3&";


    if (isSaveChecker) return;

    setIstoggleClick(false);
    if (formState.name.trim() === "") {
      toast.error("Please enter Lesson Name.", {
        position: "top-center",
      });
      setLoading(false);
      setisSaveChecker(false);
      return;
    }

    setisSaveChecker(true);
    setGlobleOnChangeDataSave(true);

    if (activeWorkboard.name === "Assignment") setClickSaveBTN(true);
    if (activeWorkboard.name === "Rubric") setClickSaveRubricBTN(true);

    // ✅ Validation for assignment fields
    if (!checkAssignmentopen && isAssignment && !generateAllMode) {
      const errors = {};
      if (isRequired(formAssignmentState?.name))
        errors.name = "Name is required";
      if (isRequired(formAssignmentState?.duration_minutes))
        errors.duration_minutes = "Timer is required";
      if (isRequired(formAssignmentState?.start_date))
        errors.start_date = "Start date is required";
      if (isRequired(formAssignmentState?.type))
        errors.type = "Type is required";

      setFormErrorAssignmentState(errors);

      if (Object.values(errors).some(Boolean)) {
        setisSaveChecker(false);
        setPopupVisible(true);
        setActiveTab('lesson')
        return;
      }
    }

    setIsSaveLoading(true);



    // ✅ LocalStorage side effects
    if (
      sessionStorage.getItem("skipLesson") === "true" &&
      (activeWorkboard.name === "Assignment" ||
        activeWorkboard.name === "Rubric")
    ) {
      setAssignmentgeneration(true);
    }

    if (
      sessionStorage.getItem("skipLesson") === "true" &&
      activeWorkboard.name === "Lesson"
    ) {
      sessionStorage.setItem("skipLesson", false);
    }

    if (SkipLessonflag && activeTab === "lesson")
      sessionStorage.setItem("DisableLessonTab", false);
    else sessionStorage.setItem("DisableLessonTab", true);

    // ✅ Payload creation
    const payload = buildPayload({
      lowerSchoolPayload,
      isAssignment,
      isRubric,
      previesAssignment,
      globleSaveData,
      formAssignmentState,
      workboards,
      lesson_id,
      assignmentsCountTwo,
      rubricCounttTwo,
      switchschoologySync,
      chatHist,
      formState,
      isPersonalizeValue,
      isSwitchOn: formState?.isSwitchOn,
      isSwitchOn2: formState?.isSwitchOn2,
      isSwitchOnLessonPreview: formState?.isSwitchOnLessonPreview,
      isSwitchOnVirtualAssistant: formState?.isSwitchOnVirtualAssistant,
      course,
      teacher_id,
      room_id,
      getassignmentdetails,
      currentHideTimerState,
      eachAssignment_id,
      generateAllMode,
      EMPTY_LESSON_PLACEHOLDER_DESCRIPTION,
      createManuallyMode,
      stopGenerateAllMode,
      lesson,
      isStoryGeneration,
      setGetSpecificAssignmentType,
      getSpecificAssignmentType
    });

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Token ${token}`,
    };

    const url = resolveURL({
      isAssignment,
      isRubric,
      lesson_id,
      rubric_id,
      previesRubric,
      eachRubric_id,
      eachAssignment_id,
      previesAssignment,
    });

    try {
      const method = shouldUsePut({
        isAssignment,
        isRubric,
        assignment_id,
        rubric_id,
        lesson_id,
        previesAssignment,
        previesRubric,
        eachAssignment_id,
        eachRubric_id,
      })
        ? "put"
        : "post";


      const response = await api[method](url, payload, { headers });
      if ([200, 201].includes(response.status)) {
        // The lesson now has saved content — gates the Student Preview.
        if (!isAssignment && !isRubric) {
          setIsLessonSaved?.(true);
        }

        // update previoursLessonData
        const fetchedLesson = await getLessons();
        const course = await getCourseDetails();

        const data = {
          lesson: fetchedLesson,
          course,
          teacher_id: params.get("teacher_id"),
        };

        // Don't mutate location.state directly — instead, store your data
        sessionStorage.setItem("previewLessonData", JSON.stringify(data));


        await handleSuccessResponse({
          response,
          isAssignment,
          isRubric,
          formState,
          fetchedLesson,
          setLesson,
          setisSaveChecker,
          schoologystatus,
          setShowCourseSuccessfully,
          setLoadingPublishSchoology,
          updateDefaultWorkboardData,
          updateWorkboardDataByName,
          updateGlobleSaveData,
          activeWorkboard,
          defaultWorkboardData,
          globleSaveData,
          setPreviesAssignment,
          setPreviesRubric,
          setEachAssignment_id,
          setEachRubric_id,
          setPopupVisible,
          setFormState,
          setassignment_id,
          setrubric_id,
          setlesson_id,
          setAssingmentListOfID,
          setGlobleSaveData,
          assignmentsCountTwo,
          rubricCounttTwo,
          formAssignmentState,
          previesAssignment,
          previesRubric,
          rubric_id,
          setHideTimerStates,
          currentHideTimerState,
          setCallSwitchToRubricFun,
          setIsAssignment,
          setIsRubric,
          setActiveWorkboard,
          workboards,
          generateAllMode,
          lesson_id,
          assignmentsCount,
          setPendingAssignmentClickArgs,
          rubricCount,
          setPendingRubricClickArgs,
          setskipLessonSession,
          skipLessonSession,
          setIsSaveLoading,
          setGetSavedYoutubeLinks,
          setTypeChanged,
          setGetSpecificAssignmentType,
          getSpecificAssignmentType,
          setFormAssignmentState
        });
      }

      setLoading(false);
    } catch (error) {
      const msg = error.response?.data?.message;
      if (msg) toast.error(msg);
      setisSaveChecker(false);
      setLoading(false);
    } finally {
      setIsSaveLoading(false);
    }
  };

  return { handleAssinmentRubricSubmit };
}

/* -------------------------------------------------------------------------- */
/*                                HELPER FUNCS                                */
/* -------------------------------------------------------------------------- */

function buildPayload(args) {
  const {
    lowerSchoolPayload,
    isAssignment,
    isRubric,
    previesAssignment,
    globleSaveData,
    formAssignmentState,
    workboards,
    lesson_id,
    assignmentsCountTwo,
    rubricCounttTwo,
    switchschoologySync,
    chatHist,
    formState,
    isPersonalizeValue,
    isSwitchOn,
    isSwitchOn2,
    isSwitchOnLessonPreview,
    isSwitchOnVirtualAssistant,
    course,
    teacher_id,
    room_id,
    getassignmentdetails,
    currentHideTimerState,
    eachAssignment_id,
    generateAllMode,
    EMPTY_LESSON_PLACEHOLDER_DESCRIPTION,
    createManuallyMode,
    stopGenerateAllMode,
    lesson,
    isStoryGeneration,
    setGetSpecificAssignmentType,
    getSpecificAssignmentType
  } = args;

  // Story generation has no "skip lesson" step — the story shell in the editor is
  // the description, so never swap it for the empty placeholder.
  const isSkippedLesson =
    !isStoryGeneration &&
    (workboards.LESSON.data === "@$%^231#^#a5fgd%532^&amp;4R3&amp;" ||
      (lesson?.description === EMPTY_LESSON_PLACEHOLDER_DESCRIPTION &&
        !generateAllMode &&
        !createManuallyMode &&
        !stopGenerateAllMode));

  // Same source as the Lesson tab: whatever the Lexical editor last synced into the
  // Lesson workboard. Story generation falls back to the seeded editor HTML in case
  // no editor update has fired yet, so the story shell is never dropped.
  const lessonWorkboardData = removeCloseImageSpans(
    workboards.LESSON.data ?? ""
  );
  const lessonDescription =
    isStoryGeneration && !lessonWorkboardData.trim()
      ? removeCloseImageSpans(formState?.description ?? "")
      : lessonWorkboardData;


  if (isAssignment) {

    const assignmentData =
      eachAssignment_id
        ? getassignmentdetails[assignmentsCountTwo - 1]
        : formAssignmentState;



    return {
      name: generateAllMode ? `${formState.name}` : formAssignmentState?.name,
      assignment: removeCloseImageSpans(workboards.ASSIGNMENT.data),
      lesson: lesson_id,
      duration_minutes: generateAllMode ? 60 : formAssignmentState?.duration_minutes,
      start_date: formAssignmentState?.start_date,
      end_date: formAssignmentState?.end_date,
      type: generateAllMode ? 7 : formAssignmentState?.type,
      synced_with_schoology: switchschoologySync,
      hide_timer: currentHideTimerState,
      ...(globleSaveData.RUBRIC.data[assignmentsCountTwo]?.Id && {
        rubric: globleSaveData.RUBRIC.data[assignmentsCountTwo].Id,
      }),
      ...(getSpecificAssignmentType && {
        new_type: getSpecificAssignmentType,
      }),
    };

  }

  if (isRubric) {
    return {
      rubric: removeCloseImageSpans(workboards.RUBRIC.data),
      lesson: lesson_id,
      synced_with_schoology: switchschoologySync,
      ...(globleSaveData.ASSIGNMENT.data[rubricCounttTwo]?.Id && {
        assignment: globleSaveData.ASSIGNMENT.data[rubricCounttTwo].Id,
      }),
    };
  }

  return {
    name: formState?.name ?? "",
    start_date: formState?.start_date ?? "",
    end_date: formState?.end_date,
    description: isSkippedLesson
      ? EMPTY_LESSON_PLACEHOLDER_DESCRIPTION
      : lessonDescription,
    course: course?.course_id ?? "",
    teacher: teacher_id,
    status: 3,
    user_query: { question: chatHist[0]?.query ?? "" },
    ai_answer: { answer: chatHist[0]?.answer ?? "" },
    room_id: room_id,
    is_personalize:
      isPersonalizeValue !== undefined ? isPersonalizeValue : isSwitchOn,
    is_file_download: isSwitchOn2,
    lesson_preview: isSwitchOnLessonPreview,
    virtual_assistant: isSwitchOnVirtualAssistant,
    synced_with_schoology: switchschoologySync,
    is_skip: false,
    hide_timer: currentHideTimerState,
    ...(lowerSchoolPayload || {}),
  };
}

function resolveURL({
  isAssignment,
  isRubric,
  lesson_id,
  rubric_id,
  previesRubric,
  eachRubric_id,
  eachAssignment_id,
  previesAssignment,
}) {


  if (isAssignment) {
    return eachAssignment_id
      ? `assignments/update-assignment/${eachAssignment_id}/`
      : "assignments/create-assignment/";
  }

  if (isRubric) {
    return rubric_id !== ""
      ? previesRubric
        ? eachRubric_id
          ? `assignments/update-rubric/${eachRubric_id}/`
          : "assignments/create-rubric/"
        : "assignments/create-rubric/"
      : "assignments/create-rubric/";
  }

  return lesson_id
    ? `lessons/update-lesson/${lesson_id}/`
    : "lessons/create-lesson/";
}

function shouldUsePut({
  isAssignment,
  isRubric,
  assignment_id,
  rubric_id,
  lesson_id,
  previesAssignment,
  previesRubric,
  eachAssignment_id,
  eachRubric_id,
}) {


  if (isAssignment) return Boolean(eachAssignment_id);
  if (isRubric) return Boolean(eachRubric_id);
  return Boolean(lesson_id);
}

async function handleSuccessResponse({
  response,
  isAssignment,
  isRubric,
  formState,
  fetchedLesson,
  setLesson,
  setisSaveChecker,
  schoologystatus,
  setShowCourseSuccessfully,
  setLoadingPublishSchoology,
  updateDefaultWorkboardData,
  updateWorkboardDataByName,
  updateGlobleSaveData,
  activeWorkboard,
  defaultWorkboardData,
  globleSaveData,
  setPreviesAssignment,
  setPreviesRubric,
  setEachAssignment_id,
  setEachRubric_id,
  setPopupVisible,
  setFormState,
  setassignment_id,
  setrubric_id,
  setlesson_id,
  setAssingmentListOfID,
  setGlobleSaveData,
  assignmentsCountTwo,
  rubricCounttTwo,
  formAssignmentState,
  previesAssignment,
  previesRubric,
  rubric_id,
  setHideTimerStates,
  currentHideTimerState,
  generateAllMode,
  setCallSwitchToRubricFun,
  setIsAssignment,
  setIsRubric,
  setActiveWorkboard,
  workboards,
  lesson_id,
  assignmentsCount,
  setPendingAssignmentClickArgs,
  rubricCount,
  setPendingRubricClickArgs,
  setskipLessonSession,
  skipLessonSession,
  setIsSaveLoading,
  setGetSavedYoutubeLinks,
  setTypeChanged,
  setGetSpecificAssignmentType,
  getSpecificAssignmentType,
  setFormAssignmentState
}) {
  sessionStorage.setItem("lesson_name", JSON.stringify(formState?.name));
  setisSaveChecker(false);
  const EMPTY_LESSON_PLACEHOLDER_DESCRIPTION_two = "This lesson was skipped to directly create an assignment.";


  if (isAssignment) {
    setHideTimerStates(prev => ({
      ...prev,
      [assignmentsCountTwo]: currentHideTimerState
    }));
  }

  if (schoologystatus === "" || schoologystatus === "syncDone") {
    setIsSaveLoading(false);
    setShowCourseSuccessfully(true);
    setLoadingPublishSchoology(false);
    setTimeout(() => {
      setShowCourseSuccessfully(false);
      if (
        activeWorkboard?.name === "Lesson" &&
        generateAllMode &&
        !isAssignment &&
        !isRubric &&
        lesson_id &&
        Array.isArray(assignmentsCount) &&
        assignmentsCount.length > 0
      ) {
        queueMicrotask(() => {
          setPendingAssignmentClickArgs?.({
            assignment: assignmentsCount[0],
            index: 0,
          });
        });
      }
      if (isAssignment && generateAllMode) {
        queueMicrotask(() => {
          setIsAssignment(false);
          setIsRubric(true);
          setActiveWorkboard(workboards.RUBRIC);
          // If rubrics already exist, select the first rubric (same as clicking "Rubric 1", index 0).
          if (Array.isArray(rubricCount) && rubricCount.length > 0) {
            setPendingRubricClickArgs?.({ rubric: rubricCount[0], index: 0 });
          } else {
            setCallSwitchToRubricFun?.(true);
          }
        });
      }
    }, 3000);
  }


  updateDefaultWorkboardData(
    isAssignment
      ? defaultWorkboardData.ASSIGNMENT.name
      : isRubric
        ? defaultWorkboardData.RUBRIC.name
        : defaultWorkboardData.LESSON.name,
    isAssignment
      ? response?.data?.data?.assignment
      : isRubric
        ? response?.data?.data?.rubric
        : response?.data?.data?.description === EMPTY_LESSON_PLACEHOLDER_DESCRIPTION_two ? "" : response?.data?.data?.description
  );

  updateGlobleSaveData(
    isAssignment
      ? globleSaveData.ASSIGNMENT.name
      : isRubric
        ? globleSaveData.RUBRIC.name
        : globleSaveData.LESSON.name,
    isAssignment
      ? response?.data?.data?.assignment
      : isRubric
        ? {
          data: response?.data?.data?.rubric ?? "",
          Id: response?.data?.data?.rubric_id ?? null,
        }
        : response?.data?.data?.description === EMPTY_LESSON_PLACEHOLDER_DESCRIPTION_two ? "" : response?.data?.data?.description
  );

  if (
    generateAllMode &&
    typeof updateWorkboardDataByName === "function"
  ) {
    if (isAssignment) {
      const html = response?.data?.data?.assignment;
      if (html != null) {
        updateWorkboardDataByName("Assignment", html, assignmentsCountTwo);
      }
    } else if (isRubric) {
      const html = response?.data?.data?.rubric;
      if (html != null) {
        updateWorkboardDataByName("Rubric", html, rubricCounttTwo);
      }
    } else {
      const html = response?.data?.data?.description === EMPTY_LESSON_PLACEHOLDER_DESCRIPTION_two ? "" : response?.data?.data?.description;
      if (html != null) {
        updateWorkboardDataByName("Lesson", html);
      }
    }
  }

  /* -------------------- FIX: STORE NEW ASSIGNMENT ID -------------------- */
  if (isAssignment) {

    const apiData = response?.data?.data;   // the inner data object
    const newId = apiData?.assignment_id;

    const newArray = {
      data: apiData?.assignment,
      Id: newId
    };

    // 🔄 Sync the assignment form state with the saved response
    if (apiData) {
      setFormAssignmentState(prev => ({
        ...prev,
        name: apiData.name ?? prev.name,
        assignment: apiData.assignment ?? prev.assignment,
        assignment_json: apiData.assignment_json ?? prev.assignment_json,
        lesson: apiData.lesson ?? prev.lesson,
        duration_minutes: apiData.duration_minutes ?? prev.duration_minutes,
        start_date: apiData.start_date ?? prev.start_date,
        end_date: apiData.end_date ?? prev.end_date,
        type: apiData.type ?? prev.type,
      }));
    }

    if (newId != null) {
      setEachAssignment_id(newId);
      setassignment_id(newId);
      setPreviesAssignment(true);

      // Update correct index in global data
      setGlobleSaveData(prev => {
        const updated = [...prev.ASSIGNMENT.data];
        updated[assignmentsCountTwo] = newArray;

        return {
          ...prev,
          ASSIGNMENT: {
            ...prev.ASSIGNMENT,
            data: updated,
          },
        };
      });
    }
  }

  const getid = isAssignment
    ? response?.data?.data?.assignment_id
    : isRubric
      ? response?.data?.data?.rubric_id
      : response?.data?.data?.lesson_id;

  if (isAssignment) {
    if (!previesAssignment) {
      const existingIds =
        JSON.parse(sessionStorage.getItem("Assingment_Id")) || [];
      const updatedIds = [...existingIds, getid];
      sessionStorage.setItem("Assingment_Id", JSON.stringify(updatedIds));
      setPreviesAssignment(true);
      setEachAssignment_id(getid);
      setPopupVisible(false);

      setFormState((prev) => ({
        ...prev,
        chat_query: "",
      }));
      setassignment_id(getid);
    }
    if (response?.data?.type_changed && response?.data?.data?.rubric_id) {
      setTimeout(() => {
        setTypeChanged?.(response?.data?.type_changed ?? false);

      }, 3100)
    }
    if (!response?.data?.type_changed) {
      setGetSpecificAssignmentType(null)
    }
  } else if (isRubric) {
    if (!previesRubric) {
      let existingIds = [];
      try {
        const raw = sessionStorage.getItem("Rubric_id");
        const parsed = raw ? JSON.parse(raw) : [];
        existingIds = Array.isArray(parsed) ? parsed : [];
      } catch {
        existingIds = [];
      }
      const idx =
        typeof rubricCounttTwo === "number" &&
          !Number.isNaN(rubricCounttTwo) &&
          rubricCounttTwo >= 0
          ? rubricCounttTwo
          : existingIds.length;
      const updatedIds = [...existingIds];
      while (updatedIds.length <= idx) {
        updatedIds.push(null);
      }
      updatedIds[idx] = getid;
      sessionStorage.setItem("Rubric_id", JSON.stringify(updatedIds));
      setPreviesRubric(true);
      setEachRubric_id(getid);
    }
    if (rubric_id === "") {
      setrubric_id(getid);
    }
  } else {



    setTimeout(() => {

      const lessonIdFromApi = response?.data?.data?.lesson_id
      const lessonDescFromApi = response?.data?.data?.description === EMPTY_LESSON_PLACEHOLDER_DESCRIPTION_two ? "" : response?.data?.data?.description;;
      const apiLesson = response?.data?.data;

      const lessonDetails = {
        Id: lessonIdFromApi,
        data: lessonDescFromApi,
      };

      const youtubeUrl = extractYoutubeUrlFromHtml(lessonDescFromApi);
      setGetSavedYoutubeLinks(youtubeUrl);

      sessionStorage.setItem("lessonDetails", JSON.stringify(lessonDetails));

      if (fetchedLesson && Object.keys(fetchedLesson).length > 0) {
        setLesson(fetchedLesson);
      } else if (apiLesson && typeof apiLesson === "object") {
        setLesson({
          ...apiLesson,
          lesson_id: lessonIdFromApi ?? apiLesson.lesson_id,
          description: lessonDescFromApi ?? apiLesson.description,
          name: formState?.name ?? apiLesson.name,
        });
      } else {
        setLesson((prev) => ({
          ...prev,
          lesson_id: lessonIdFromApi ?? prev?.lesson_id,
          description: lessonDescFromApi ?? prev?.description,
          name: formState?.name ?? prev?.name,
        }));
      }

      if (!lesson_id || lesson_id === "") {
        setlesson_id(lessonIdFromApi);
      }


      if (skipLessonSession) {
        setskipLessonSession(false)
      }
    }, 3100);
  }

}
